
<div v-if="filter">
    <v-row class="no-frame">
        <v-col class="no-frame mr-1 lm-border pa-3">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        :label  = "$t('contract.mnt.title')"
                        v-model = "filter.maintenance"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                    <c-tag
                        class="mt-2"
                        :label="$t('contract.mnt.label')"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        :label  = "$t('contract.esc.title')"
                        v-model = "filter.escalation"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                    <c-tag
                        class="mt-2"
                        :label="$t('contract.esc.label')"
                    />
                </v-col>
            </v-row>
        </v-col>
        <v-col class="no-frame lm-border pa-3 ml-1">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "aktiv"
                        v-model = "filter.active"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "inaktiv"
                        v-model = "filter.inactive"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame mt-2 lm-border pa-3">
            <v-radio-group
                v-model="filter.role"
                class="mt-0 mb-0"
                @change="onChangeRole"
                hide-details
            >
                <!--
                <v-radio
                    :ripple = "false"
                    :value="0"
                >
                    <template v-slot:label>
                        <div class="v-flex">
                            <div>
                                Alle Rollen
                            </div>
                        </div>
                    </template>
                </v-radio>
                -->
                <v-radio
                    :ripple = "false"
                    :value="1"
                >
                    <template v-slot:label>
                        <div class="v-flex">
                            <div>
                                Rolle als
                            </div>
                            <c-tag
                                class="ml-2 mr-2"
                                :label="$t('msd.service.role.mnt.label')"
                            />
                            <div class="primary--text" style="font-size: 15px; padding-top: 0px;"> oder </div>

                            <c-tag
                                class="ml-2"
                                :label="$t('msd.service.role.esc.label')"
                            />
                        </div>
                    </template>
                </v-radio>
                <v-radio
                    :ripple = "false"
                    :value="2"
                >
                    <template v-slot:label>
                        <div class="v-flex">
                            <div>
                                Rolle als
                            </div>
                            <c-tag
                                class="ml-2 mr-2"
                                :label="$t('msd.service.role.srv.label')"
                            />
                        </div>
                    </template>
                </v-radio>
                <v-radio
                    :ripple = "false"
                    :value="3"
                >
                    <template v-slot:label>
                        <div class="v-flex">
                            <div>
                                Rolle als
                            </div>
                            <c-tag
                                class="ml-2 mr-2"
                                :label="$t('msd.service.role.adm.label')"
                            />
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
        </v-col>
    </v-row>
</div>
